import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxDropzoneModule } from 'ngx-dropzone';
const MAT_DATE_FORMATS ="";
import {
  MatFormFieldModule,
  MatToolbarModule,
  MatTreeModule,
  MatButtonModule,
  MatCheckboxModule,
  MatRadioModule,
  MatCardModule,
  MatInputModule,
  MatSlideToggleModule,
  MatDialogModule,
  MatSidenavModule,
  MatStepperModule,
  MatSnackBarModule,
  MatTableModule,
  MatExpansionModule,
  MatDatepickerModule,
  MatIconModule,
  MatSelectModule,
  MatAutocompleteModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatSortModule,
  MatRippleModule,
  MatProgressSpinnerModule,
  MatChipsModule,
  MatTabsModule,
  MatListModule,
  NativeDateModule,
  MatMenuModule,
  MatButtonToggleModule,
  MatTooltipModule,
} from '@angular/material';
import { TextMaskModule } from 'angular2-text-mask';

const MATERIAL_MODULE = [
  TextMaskModule,
  MatDialogModule, 
  MatFormFieldModule,
  MatToolbarModule,
  MatButtonModule, 
  MatInputModule,
  NgxDropzoneModule,
  MatRippleModule,
  MatFormFieldModule,
  MatTreeModule,
  MatNativeDateModule,
  MatDatepickerModule,
  MatAutocompleteModule,
  MatButtonModule,
  MatCheckboxModule,
  MatRadioModule,
  MatCardModule,
  MatInputModule,
  MatSlideToggleModule,
  MatDialogModule,
  MatSidenavModule,
  MatStepperModule,
  MatSnackBarModule,
  MatTableModule,
  MatExpansionModule,
  MatIconModule,
  MatSelectModule,
  MatPaginatorModule,
  MatSortModule,
  MatProgressSpinnerModule,
  MatChipsModule,
  MatTabsModule,
  MatListModule,
  NativeDateModule,
  MatMenuModule,
  MatButtonToggleModule,
  MatTooltipModule,
]

@NgModule({
  imports: [
    CommonModule,
    ...MATERIAL_MODULE
  ],
  exports: [
    ...MATERIAL_MODULE
  ],
  declarations: [],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: ['l', 'LL'],
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
  ]
})
export class CustomMaterialModule { }
